import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Project from "./pages/Project";
import MilanooDetails from "./pages/MilanooDetails";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Campaigns from "./pages/Campaigns";
import DigitalMarketing from "./pages/DigitalMarketing";
import Branding from "./pages/Branding";
import UIUX from "./pages/UIUX";
import Blog from "./pages/Blog";
import BlogDetails1 from "./pages/BlogDetails1";
import BlogDetails2 from "./pages/BlogDetails2";
import BlogDetails3 from "./pages/BlogDetails3";
import BlogDetails4 from "./pages/BlogDetails4";
import BlogDetails5 from "./pages/BlogDetails5";
import BlogDetails6 from "./pages/BlogDetails6";
import BlogDetails7 from "./pages/BlogDetails7";
import Careers from "./pages/Careers";
import CareerDetails1 from "./pages/CareerDetails1";
import CareerDetails2 from "./pages/CareerDetails2";
import CareerDetails3 from "./pages/CareerDetails3";
import CareerDetails4 from "./pages/CareerDetails4";
import CareerDetails5 from "./pages/CareerDetails5";
import CareerDetails6 from "./pages/CareerDetails6";
import CareerDetails7 from "./pages/CareerDetails7";
import ApplyJob from "./pages/ApplyJob";
import CookiesPolicies from "./pages/Cookiespolicy";
import PrivacyPolicy from "./pages/Privacypolicy";
import TermsAndCondition from "./pages/TermsAndCondition";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/project" element={<Project />} />
        <Route path="/milanoodetails" element={<MilanooDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/digital-marketing" element={<DigitalMarketing />} />

        {/* UI/UX Page */}
        <Route path="/ui-ux" element={<UIUX />} />
        <Route path="/ui-ux-design" element={<UIUX />} />

        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-details-1" element={<BlogDetails1 />} />
<Route path="/blog-details-2" element={<BlogDetails2 />} />
<Route path="/blog-details-3" element={<BlogDetails3 />} />
<Route path="/blog-details-4" element={<BlogDetails4 />} />
<Route path="/blog-details-5" element={<BlogDetails5 />} />
<Route path="/blog-details-6" element={<BlogDetails6 />} />
<Route path="/blog-details-7" element={<BlogDetails7 />} />
        <Route path="/careers" element={<Careers />} />

        <Route path="/career-details-1" element={<CareerDetails1 />} />
        <Route path="/career-details-2" element={<CareerDetails2 />} />
        <Route path="/career-details-3" element={<CareerDetails3 />} />
        <Route path="/career-details-4" element={<CareerDetails4 />} />
        <Route path="/career-details-5" element={<CareerDetails5 />} />
        <Route path="/career-details-6" element={<CareerDetails6 />} />
        <Route path="/career-details-7" element={<CareerDetails7 />} />

        <Route path="/apply-job" element={<ApplyJob />} />

        <Route path="/cookiesandolicies" element={<CookiesPolicies />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termsandcondition" element={<TermsAndCondition />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;